import { useState } from "react";
import { 
    MdClose
} from 'react-icons/md';


const EditContact = (props) => {

    const [name, setName] = useState(props.new ? '':props.contact.name);
    const [contact, setContact] = useState(props.new ? '':props.contact.contact);

    const save = () => {

        if(name.trim().length == 0){
            return window.alert('Ingresa un nombre valido.');
        }

        if(parseInt(contact.trim()).toString().length < 8){
            return window.alert('Ingresa un numero de telefono valido.');
        }


        const newContacts = props.contacts.slice();

        if(props.new){
            if(newContacts[props.contactPos]){
                newContacts[props.contactsPos].push({name: name, contact: contact});
                props.setContacts(newContacts);
            }else{
                newContacts[props.contactsPos] = [{name: name, contact: contact}]
                props.setContacts(newContacts);
            }
            props.close();
        }else if(props.delete){
            newContacts[props.contactsPos] = newContacts[props.contactsPos].filter(element => element != props.contact);
            props.setContacts(newContacts);
            props.close();
        }else{
            newContacts[props.contactsPos][props.contactPos] = {...props.contact, name: name, contact: contact};
            props.setContacts(newContacts);
            props.close();
        }

        props.export('Contacts', props.contactsPos, 'contacts', newContacts[props.contactsPos]);
    }

    return (
        <>
            <div>
                Nombre: <input type='text' value={name} onChange={(e) => setName(e.target.value)} disabled={props.delete} />
            </div>
            <div className='mt-1'>
                Numero: <input type='text' value={contact} onChange={(e) => setContact(e.target.value)} disabled={props.delete} />
            </div>
            <div className="mt-2">
                <button className={props.delete? 'm-auto btn btn-cancel':'m-auto btn btn-accept'} onClick={save}>{props.delete?'Borrar':'Guardar'}</button>
            </div>

        </>
    );
}

export default EditContact;